export var OrganisationFeatureFlags;
(function (OrganisationFeatureFlags) {
    /** QBO companies will also send invoice reference as statement memo  */
    OrganisationFeatureFlags["QBO_STATEMENT_MEMO_INVOICE_REF"] = "QBO_STATEMENT_MEMO_INVOICE_REF";
    OrganisationFeatureFlags["MANUAL_PARENT_CHILD"] = "MANUAL_PARENT_CHILD";
    OrganisationFeatureFlags["CONSOLIDATE_PDF_ATTACHMENTS"] = "CONSOLIDATE_PDF_ATTACHMENTS";
    OrganisationFeatureFlags["PUBLIC_API"] = "PUBLIC_API";
    OrganisationFeatureFlags["AI_AGENT"] = "AI_AGENT";
    OrganisationFeatureFlags["AI_STATEMENT_BUILDER"] = "AI_STATEMENT_BUILDER";
    /** Can use the AI statement builder, but can't switch statements over to the custom template */
    OrganisationFeatureFlags["AI_STATEMENT_BUILDER_PARTIAL"] = "AI_STATEMENT_BUILDER_PARTIAL";
    /** In-app AI assistant for configuring policies and groups */
    OrganisationFeatureFlags["AI_ASSISTANT"] = "AI_ASSISTANT";
    /** Click to call from the contact page (Twilio rings the user, then bridges the contact) */
    OrganisationFeatureFlags["CLICK_TO_CALL"] = "CLICK_TO_CALL";
    /** Click to call may use the shared Paidnice caller IDs. Without it the org calls only from numbers it bought */
    OrganisationFeatureFlags["ALLOWED_SHARED_NUMBERS"] = "ALLOWED_SHARED_NUMBERS";
    /** Click to call may buy US numbers and dial US destinations. Off for everyone until the US wave (#6700) */
    OrganisationFeatureFlags["US_CALLING"] = "US_CALLING";
    /** Portal customers can save and manage Stripe payment methods */
    OrganisationFeatureFlags["PORTAL_PAYMENT_METHODS"] = "PORTAL_PAYMENT_METHODS";
    /** Reminder policies can use the Intelligent Dynamic template, where AI writes each email at send time */
    OrganisationFeatureFlags["INTELLIGENT_DYNAMIC_EMAILS"] = "INTELLIGENT_DYNAMIC_EMAILS";
    /** Dashboard widget where the AI reviews the account and suggests actions (needs AI_ASSISTANT consent) */
    OrganisationFeatureFlags["AI_SUGGESTIONS"] = "AI_SUGGESTIONS";
    /** Per-org inbox+<token> address users can auto-forward their mailbox to */
    OrganisationFeatureFlags["EMAIL_FORWARDING_ADDRESS"] = "EMAIL_FORWARDING_ADDRESS";
    /** Record LogRocket session replays of this org's customers on the portal */
    OrganisationFeatureFlags["PORTAL_SESSION_REPLAY"] = "PORTAL_SESSION_REPLAY";
})(OrganisationFeatureFlags || (OrganisationFeatureFlags = {}));
export var OrganisationEmailProvider;
(function (OrganisationEmailProvider) {
    OrganisationEmailProvider["SENDGRID"] = "sendgrid";
    OrganisationEmailProvider["MAILGUN"] = "mailgun";
})(OrganisationEmailProvider || (OrganisationEmailProvider = {}));
//# sourceMappingURL=organisation.js.map